/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangeRoleIn,
  HTTPValidationError,
  InvitationCreatedOut,
  InviteUserIn,
  ListOrgUsersParams,
  MessageResponse,
  OrgUserOut,
  PaginatedOrgUserOut,
  PendingInvitationsOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listOrgUsersResponse200 = {
  data: PaginatedOrgUserOut
  status: 200
}

export type listOrgUsersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listOrgUsersResponseSuccess = (listOrgUsersResponse200) & {
  headers: Headers;
};
export type listOrgUsersResponseError = (listOrgUsersResponse422) & {
  headers: Headers;
};

export type listOrgUsersResponse = (listOrgUsersResponseSuccess | listOrgUsersResponseError)

export const getListOrgUsersUrl = (params?: ListOrgUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/org-users?${stringifiedParams}` : `/api/org-users`
}

/**
 * @summary List Org Users
 */
export const listOrgUsers = async (params?: ListOrgUsersParams, options?: Parameters<typeof apiFetch>[1]): Promise<listOrgUsersResponse> => {

  return apiFetch<listOrgUsersResponse>(getListOrgUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrgUsersQueryKey = (params?: ListOrgUsersParams,) => {
    return [
    `/api/org-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrgUsersQueryOptions = <TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = HTTPValidationError>(params?: ListOrgUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgUsers>>> = ({ signal }) => listOrgUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgUsers>>>
export type ListOrgUsersQueryError = HTTPValidationError


export function useListOrgUsers<TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = HTTPValidationError>(
 params: undefined |  ListOrgUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgUsers>>,
          TError,
          Awaited<ReturnType<typeof listOrgUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgUsers<TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = HTTPValidationError>(
 params?: ListOrgUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgUsers>>,
          TError,
          Awaited<ReturnType<typeof listOrgUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgUsers<TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = HTTPValidationError>(
 params?: ListOrgUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Org Users
 */

export function useListOrgUsers<TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = HTTPValidationError>(
 params?: ListOrgUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listOrgInvitationsResponse200 = {
  data: PendingInvitationsOut
  status: 200
}

export type listOrgInvitationsResponseSuccess = (listOrgInvitationsResponse200) & {
  headers: Headers;
};
;

export type listOrgInvitationsResponse = (listOrgInvitationsResponseSuccess)

export const getListOrgInvitationsUrl = () => {




  return `/api/org-users/invitations`
}

/**
 * @summary List Org Invitations
 */
export const listOrgInvitations = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listOrgInvitationsResponse> => {

  return apiFetch<listOrgInvitationsResponse>(getListOrgInvitationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrgInvitationsQueryKey = () => {
    return [
    `/api/org-users/invitations`
    ] as const;
    }


export const getListOrgInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listOrgInvitations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgInvitations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgInvitationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgInvitations>>> = ({ signal }) => listOrgInvitations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgInvitations>>>
export type ListOrgInvitationsQueryError = unknown


export function useListOrgInvitations<TData = Awaited<ReturnType<typeof listOrgInvitations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgInvitations>>,
          TError,
          Awaited<ReturnType<typeof listOrgInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgInvitations<TData = Awaited<ReturnType<typeof listOrgInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgInvitations>>,
          TError,
          Awaited<ReturnType<typeof listOrgInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgInvitations<TData = Awaited<ReturnType<typeof listOrgInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgInvitations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Org Invitations
 */

export function useListOrgInvitations<TData = Awaited<ReturnType<typeof listOrgInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgInvitations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgInvitationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type inviteOrgUserResponse201 = {
  data: InvitationCreatedOut
  status: 201
}

export type inviteOrgUserResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type inviteOrgUserResponseSuccess = (inviteOrgUserResponse201) & {
  headers: Headers;
};
export type inviteOrgUserResponseError = (inviteOrgUserResponse422) & {
  headers: Headers;
};

export type inviteOrgUserResponse = (inviteOrgUserResponseSuccess | inviteOrgUserResponseError)

export const getInviteOrgUserUrl = () => {




  return `/api/org-users/invitations`
}

/**
 * @summary Invite Org User
 */
export const inviteOrgUser = async (inviteUserIn: InviteUserIn, options?: Parameters<typeof apiFetch>[1]): Promise<inviteOrgUserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<inviteOrgUserResponse>(getInviteOrgUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inviteUserIn)
  }
);}





export const getInviteOrgUserMutationKey = () => ['inviteOrgUser'] as const;

export const getInviteOrgUserMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOrgUser>>, TError,InviteOrgUserMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteOrgUser>>, TError,InviteOrgUserMutationVariables, TContext> => {

const mutationKey = getInviteOrgUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteOrgUser>>, InviteOrgUserMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  inviteOrgUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteOrgUserMutationResult = NonNullable<Awaited<ReturnType<typeof inviteOrgUser>>>
    export type InviteOrgUserMutationBody = InviteUserIn
    export type InviteOrgUserMutationError = HTTPValidationError
    export type InviteOrgUserMutationVariables = {data: InviteUserIn}

    /**
 * @summary Invite Org User
 */
export const useInviteOrgUser = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOrgUser>>, TError,InviteOrgUserMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteOrgUser>>,
        TError,
        InviteOrgUserMutationVariables,
        TContext
      > => {
      return useMutation(getInviteOrgUserMutationOptions(options), queryClient);
    }
    export type cancelOrgInvitationResponse204 = {
  data: void
  status: 204
}

export type cancelOrgInvitationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type cancelOrgInvitationResponseSuccess = (cancelOrgInvitationResponse204) & {
  headers: Headers;
};
export type cancelOrgInvitationResponseError = (cancelOrgInvitationResponse422) & {
  headers: Headers;
};

export type cancelOrgInvitationResponse = (cancelOrgInvitationResponseSuccess | cancelOrgInvitationResponseError)

export const getCancelOrgInvitationUrl = (invitationId: number,) => {




  return `/api/org-users/invitations/${invitationId}`
}

/**
 * @summary Cancel Org Invitation
 */
export const cancelOrgInvitation = async (invitationId: number, options?: Parameters<typeof apiFetch>[1]): Promise<cancelOrgInvitationResponse> => {

  return apiFetch<cancelOrgInvitationResponse>(getCancelOrgInvitationUrl(invitationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCancelOrgInvitationMutationKey = () => ['cancelOrgInvitation'] as const;

export const getCancelOrgInvitationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrgInvitation>>, TError,CancelOrgInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOrgInvitation>>, TError,CancelOrgInvitationMutationVariables, TContext> => {

const mutationKey = getCancelOrgInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOrgInvitation>>, CancelOrgInvitationMutationVariables> = (props) => {
          const {invitationId} = props ?? {};

          return  cancelOrgInvitation(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelOrgInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOrgInvitation>>>

    export type CancelOrgInvitationMutationError = HTTPValidationError
    export type CancelOrgInvitationMutationVariables = {invitationId: number}

    /**
 * @summary Cancel Org Invitation
 */
export const useCancelOrgInvitation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrgInvitation>>, TError,CancelOrgInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelOrgInvitation>>,
        TError,
        CancelOrgInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getCancelOrgInvitationMutationOptions(options), queryClient);
    }
    export type changeOrgUserRoleResponse200 = {
  data: OrgUserOut
  status: 200
}

export type changeOrgUserRoleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type changeOrgUserRoleResponseSuccess = (changeOrgUserRoleResponse200) & {
  headers: Headers;
};
export type changeOrgUserRoleResponseError = (changeOrgUserRoleResponse422) & {
  headers: Headers;
};

export type changeOrgUserRoleResponse = (changeOrgUserRoleResponseSuccess | changeOrgUserRoleResponseError)

export const getChangeOrgUserRoleUrl = (userId: number,) => {




  return `/api/org-users/${userId}`
}

/**
 * @summary Change Org User Role
 */
export const changeOrgUserRole = async (userId: number,
    changeRoleIn: ChangeRoleIn, options?: Parameters<typeof apiFetch>[1]): Promise<changeOrgUserRoleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<changeOrgUserRoleResponse>(getChangeOrgUserRoleUrl(userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changeRoleIn)
  }
);}





export const getChangeOrgUserRoleMutationKey = () => ['changeOrgUserRole'] as const;

export const getChangeOrgUserRoleMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeOrgUserRole>>, TError,ChangeOrgUserRoleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeOrgUserRole>>, TError,ChangeOrgUserRoleMutationVariables, TContext> => {

const mutationKey = getChangeOrgUserRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeOrgUserRole>>, ChangeOrgUserRoleMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  changeOrgUserRole(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeOrgUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof changeOrgUserRole>>>
    export type ChangeOrgUserRoleMutationBody = ChangeRoleIn
    export type ChangeOrgUserRoleMutationError = HTTPValidationError
    export type ChangeOrgUserRoleMutationVariables = {userId: number;data: ChangeRoleIn}

    /**
 * @summary Change Org User Role
 */
export const useChangeOrgUserRole = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeOrgUserRole>>, TError,ChangeOrgUserRoleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeOrgUserRole>>,
        TError,
        ChangeOrgUserRoleMutationVariables,
        TContext
      > => {
      return useMutation(getChangeOrgUserRoleMutationOptions(options), queryClient);
    }
    export type removeOrgUserResponse204 = {
  data: void
  status: 204
}

export type removeOrgUserResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type removeOrgUserResponseSuccess = (removeOrgUserResponse204) & {
  headers: Headers;
};
export type removeOrgUserResponseError = (removeOrgUserResponse422) & {
  headers: Headers;
};

export type removeOrgUserResponse = (removeOrgUserResponseSuccess | removeOrgUserResponseError)

export const getRemoveOrgUserUrl = (userId: number,) => {




  return `/api/org-users/${userId}`
}

/**
 * @summary Remove Org User
 */
export const removeOrgUser = async (userId: number, options?: Parameters<typeof apiFetch>[1]): Promise<removeOrgUserResponse> => {

  return apiFetch<removeOrgUserResponse>(getRemoveOrgUserUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveOrgUserMutationKey = () => ['removeOrgUser'] as const;

export const getRemoveOrgUserMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgUser>>, TError,RemoveOrgUserMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOrgUser>>, TError,RemoveOrgUserMutationVariables, TContext> => {

const mutationKey = getRemoveOrgUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrgUser>>, RemoveOrgUserMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  removeOrgUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrgUserMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrgUser>>>

    export type RemoveOrgUserMutationError = HTTPValidationError
    export type RemoveOrgUserMutationVariables = {userId: number}

    /**
 * @summary Remove Org User
 */
export const useRemoveOrgUser = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgUser>>, TError,RemoveOrgUserMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeOrgUser>>,
        TError,
        RemoveOrgUserMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveOrgUserMutationOptions(options), queryClient);
    }
    export type resetOrgUserMfaResponse200 = {
  data: MessageResponse
  status: 200
}

export type resetOrgUserMfaResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type resetOrgUserMfaResponseSuccess = (resetOrgUserMfaResponse200) & {
  headers: Headers;
};
export type resetOrgUserMfaResponseError = (resetOrgUserMfaResponse422) & {
  headers: Headers;
};

export type resetOrgUserMfaResponse = (resetOrgUserMfaResponseSuccess | resetOrgUserMfaResponseError)

export const getResetOrgUserMfaUrl = (userId: number,) => {




  return `/api/org-users/${userId}/reset-mfa`
}

/**
 * @summary Reset Org User Mfa
 */
export const resetOrgUserMfa = async (userId: number, options?: Parameters<typeof apiFetch>[1]): Promise<resetOrgUserMfaResponse> => {

  return apiFetch<resetOrgUserMfaResponse>(getResetOrgUserMfaUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetOrgUserMfaMutationKey = () => ['resetOrgUserMfa'] as const;

export const getResetOrgUserMfaMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetOrgUserMfa>>, TError,ResetOrgUserMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetOrgUserMfa>>, TError,ResetOrgUserMfaMutationVariables, TContext> => {

const mutationKey = getResetOrgUserMfaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetOrgUserMfa>>, ResetOrgUserMfaMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  resetOrgUserMfa(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetOrgUserMfaMutationResult = NonNullable<Awaited<ReturnType<typeof resetOrgUserMfa>>>

    export type ResetOrgUserMfaMutationError = HTTPValidationError
    export type ResetOrgUserMfaMutationVariables = {userId: number}

    /**
 * @summary Reset Org User Mfa
 */
export const useResetOrgUserMfa = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetOrgUserMfa>>, TError,ResetOrgUserMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetOrgUserMfa>>,
        TError,
        ResetOrgUserMfaMutationVariables,
        TContext
      > => {
      return useMutation(getResetOrgUserMfaMutationOptions(options), queryClient);
    }
